import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundResponseResolver } from './pages/page-not-found/page-not-found-resolver.service';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PasswordResetComponent } from './pages/password-reset-page/password-reset-page.component';
import { SignupPageComponent } from './pages/signup-page/signup-page.component';

const appRoutes: Routes = [
    {
        path: 'signup',
        component: SignupPageComponent
    },
    {
        path: 'forgot-password',
        component: PasswordResetComponent
    },
    {
        path: '**',
        component: PageNotFoundComponent,
        resolve: {
            _: PageNotFoundResponseResolver
        }
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            enableTracing: false,
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            scrollOffset: [0, 24],
            initialNavigation: 'enabledNonBlocking'
        }),
    ],
    exports: [
        RouterModule
    ]
})
export class AppRoutesModule {

}
